import { createContext } from 'react';

interface ILoginContext {
  step: number;
  handleNextStep: () => void;
  handlePreviousStep: () => void;
  email: string;
  setEmail: (email: string) => void;
}

export const LoginContext = createContext<ILoginContext>({
  step: 0,
  handleNextStep: () => undefined,
  handlePreviousStep: () => undefined,
  email: '',
  setEmail: () => undefined,
});
